import dayjs from 'dayjs'
import 'react-day-picker/dist/style.css'
import { AppHeader } from '../../common/components'
import { useOfficeSelection} from '../../common/hooks'
import OfficeContainer from './OfficeContainer'
import OfficeContext from './OfficeContext'
import DateContext from './DateContext'
import { useState, useEffect } from "react"
import './index.css'

function SeatMapView({ isOps }) {
  useEffect(() => {
    document.title = 'Table Booking System';
  }, []);
  
    const [officeName, setOfficeName] = useState('Athlone');
    const date = dayjs().format('YYYY-MM-DD');
    const [offices] = useOfficeSelection();

  return (
    <>
      <OfficeContext.Provider value={{ officeName, setOfficeName }}>
        <DateContext.Provider value={{ date }}>
          <AppHeader isOps={isOps} />
          <OfficeContainer data={offices}/>
        </DateContext.Provider>            
      </OfficeContext.Provider>
    </>
  )
}

export { SeatMapView }
